import { render } from "./AvailableFacultyDataTable.vue?vue&type=template&id=51eb1c69"
import script from "./AvailableFacultyDataTable.vue?vue&type=script&lang=js"
export * from "./AvailableFacultyDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__